

















































import Vue from 'vue'
import { mapGetters, mapMutations, mapState } from 'vuex'
import List from '~/components/car/dealers/map/list/List'
import Facets from '~/components/car/dealers/map/facets/Facets'
import MobileListMapToggleButton from '~/components/car/dealers/map/MobileListMapToggleButton'
import {
  SET_PARAMS,
  TOGGLE_MOBILE_FACETS_VISIBLE
} from '~/store/modules/shared/dealers/map/mutation-types'
import DealersMap from '~/components/car/dealers/map/map/DealersMap.vue'
import { DEALERS_MAP_NS } from '~/store/modules/shared/dealers/map/state'
import CFacetsFloatingButton from '~/components/shared/configurable/button/CFacetsFloatingButton.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'

export default Vue.extend({
  components: {
    CFacetsFloatingButton,
    List,
    Facets,
    DealersMap,
    MobileListMapToggleButton
  },
  async asyncData({ store, route }) {
    store.commit(`dealers/map/${SET_PARAMS}`, {
      ...store.state.dealers.map.params,
      ...route.query
    })
    await store.dispatch('dealers/map/search')
  },
  computed: {
    ...mapState(DEALERS_MAP_NS, {
      loading: (state): boolean => state.loading,
      mobileFacetsVisible: (state): boolean => state.mobile.facetsVisible,
      mobileListVisible: (state): boolean => state.mobile.listVisible
    }),
    ...mapGetters(DEALERS_MAP_NS, {
      facetsCount: 'getFacetsCount'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isPc: 'isPc'
    })
  },
  methods: {
    ...mapMutations(DEALERS_MAP_NS, {
      toggleMobileFacetsVisible: TOGGLE_MOBILE_FACETS_VISIBLE
    })
  },
  head() {
    return {
      title: this.$t('dealers catalogue'),
      bodyAttrs: {
        class: 'full-screen'
      }
    }
  }
})
